/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_LogisticsInputs */

const en_role_logistics = /** @type {(inputs: Role_LogisticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistics`)
};

const es_role_logistics = /** @type {(inputs: Role_LogisticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistica`)
};

/**
* | output |
* | --- |
* | "Logistics" |
*
* @param {Role_LogisticsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const role_logistics = /** @type {((inputs?: Role_LogisticsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_LogisticsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_logistics(inputs)
	return es_role_logistics(inputs)
});